import { RSAA } from 'redux-api-middleware';
import { getQueryStringValueByName, getPayload } from '../../utils';
import { CASE_ID, OFFER_CASE_ID, ANALYTICS_ERROR } from '../../utils/constants';
import * as analytics from '../../utils/analytics';
import { technicalErrorPage, getExistingUser } from '../../store/dataCapture/actions';
import { getNextCall } from '../../infrastructure/offers/actions';
export const FETCH_CASE = 'FETCH_CASE';
export const FETCH_CASE_SUCCESS = 'FETCH_CASE_SUCCESS';
export const FETCH_CASE_FAILED = 'FETCH_CASE_FAILED';
export const GET_PORTAL_CASE = 'GET_PORTAL_CASE';
export const GET_PORTAL_CASE_SUCCESS = 'GET_PORTAL_CASE_SUCCESS';
export const GET_PORTAL_CASE_FAILED = 'GET_PORTAL_CASE_FAILED';

export const fetchCase = (callNextTask = false) => ({
  [RSAA]: {
    endpoint: `:api_paas_url/banks/:bank_id/cases/business/current/${getQueryStringValueByName(
      OFFER_CASE_ID
    ) || getQueryStringValueByName(CASE_ID)}/tasks/capture`,
    method: 'GET',
    headers: {
      'x-bpi-version': '1.0.0'
    },
    types: [
      {
        type: FETCH_CASE,
        meta: {
          isCaseLoaded: true,
          loading: !callNextTask
        }
      },
      {
        type: FETCH_CASE_SUCCESS,
        payload: (action, state, res) => getPayload(action, state, res),
        meta: () => {
          return !callNextTask
            ? { isCaseLoaded: false }
            : {
                nextAction: getNextCall(true),
                isCaseLoaded: false
              };
        }
      },
      {
        type: FETCH_CASE_FAILED,
        meta: () => {
          analytics.error({
            errorCode: 0,
            errorMessage: ANALYTICS_ERROR.FETCH_CASE_FAILED
          });
          return { nextAction: technicalErrorPage(), isCaseLoaded: false };
        }
      }
    ]
  }
});

export const getCases = () => ({
  [RSAA]: {
    endpoint: `:api_paas_url/banks/:bank_id/cases`,
    method: 'GET',
    headers: {
      'x-bpi-version': '1.0.0'
    },
    types: [
      {
        type: GET_PORTAL_CASE,
        meta: {
          isCaseLoaded: true
        }
      },
      {
        type: GET_PORTAL_CASE_SUCCESS,
        payload: (action, state, res) => getPayload(action, state, res),
        meta: { isCaseLoaded: false, nextAction: getExistingUser() }
      },
      {
        type: GET_PORTAL_CASE_FAILED,
        meta: () => {
          analytics.error({
            errorCode: 0,
            errorMessage: ANALYTICS_ERROR.FETCH_CASE_FAILED
          });
          return { nextAction: technicalErrorPage(), isCaseLoaded: false };
        }
      }
    ]
  }
});
